export default __webpack_public_path__ + "static/bg4-9c0290f58556907afb870682a38abcd7.jpg";